import * as React from "react";
import { Link } from "react-router-dom";

import BackButton from "../../core/BackButton/BackButton";
import Spinner from "../../core/Spinner/Spinner";

import TableBooleanFilter from "../../core/TableBooleanFilter/TableBooleanFilter";
import TableTextFilter from "../../core/TableTextFilter/TableTextFilter";

import { sessionGetItem, sessionSetItem } from "../../helpers/storage";
import { ITranslationProps, translateComponent } from "../../helpers/translation";

import IClientSearchRequest from "../../types/IClientSearchRequest";
import IClientSearchResult from "../../types/IClientSearchResult";

import ClientRow from "./ClientRow";

interface IClientListProps extends ITranslationProps {
    loading: boolean;
    records: IClientSearchResult[];
    moreRecordsExist: boolean;
    canLoginAsClient: boolean;
    search: (criteria: IClientSearchRequest, resetPage: boolean) => void;
}

interface IClientListState {
    clientName: string;
    isActive: boolean;
}

class ClientList extends React.Component<IClientListProps, IClientListState> {

    private stateStorageKey = "clientList_state_storage";

    constructor(props: IClientListProps) {
        super(props);

        this.state = {
            clientName: "",
            isActive: true
        };

        this.updateClientName = this.updateClientName.bind(this);
        this.search = this.search.bind(this);
        this.loadNextPage = this.loadNextPage.bind(this);
        this.onActiveFilterChange = this.onActiveFilterChange.bind(this);
    }

    public componentDidMount() {
        const savedState = sessionGetItem<IClientListState>(this.stateStorageKey);
        if (savedState) {
            this.setState(savedState, () => {
                this.props.search(this.getSearchRequest(), true);
            });
        } else {
            this.props.search(this.getSearchRequest(), true);
        }
    }

    public componentWillUnmount() {
        sessionSetItem(this.stateStorageKey, this.state);
    }

    public render() {

        const userRows: React.ReactNode[] = [];

        this.props.records.forEach(record => {
            userRows.push(<ClientRow key={record.id} canLoginAsClient={this.props.canLoginAsClient} {...record} />);
        });

        return (
            <div>
                {this.props.loading && <Spinner />}

                <BackButton />
                <div>
                    <h2 className="float-left">{this.props.t("ClientList.Title")}</h2>
                    <Link className="btn btn-primary float-right" to="/client">{this.props.t("ClientList.CreateNewClient")}</Link>
                </div>

                <table className="table table-sm">
                    <thead className="thead-light">
                        <tr>
                            <th>
                                <div>{this.props.t("ClientList.ClientName")}</div>
                                <TableTextFilter onChange={this.updateClientName} searchButtonClick={this.search} value={this.state.clientName} />
                            </th>
                            <th>
                                <div>{this.props.t("ClientList.IsActiveLabel")}</div>
                                <TableBooleanFilter value={this.state.isActive} trueLabel={this.props.t("Global.Active")} falseLabel={this.props.t("Global.Inactive")} onChange={this.onActiveFilterChange} />
                            </th>
                            {
                                this.props.canLoginAsClient &&
                                <th>
                                    <div>{this.props.t("ClientList.LoginLink")}</div>
                                </th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {userRows}
                    </tbody>
                </table>
                {
                    this.props.moreRecordsExist &&
                    <button data-id="showMoreButton" className="btn btn-outline-secondary" onClick={this.loadNextPage}>{this.props.t("Global.ShowMore")}
                    </button>
                }

            </div>
        );
    }

    private updateClientName(value: string) {
        this.setState({ clientName: value }, this.search);
    }

    private onActiveFilterChange(value: boolean): void {
        this.setState({ isActive: value }, this.search);
    }

    private search() {
        this.props.search(this.getSearchRequest(), true);
    }

    private loadNextPage() {
        this.props.search(this.getSearchRequest(), false);
    }

    private getSearchRequest(): IClientSearchRequest {
        return {
            clientName: this.state.clientName,
            showActive: this.state.isActive,
        }
    }
}

export default translateComponent(ClientList);



// WEBPACK FOOTER //
// ./src/components/ClientList/ClientList.tsx